// Scroll-spy for the page nav.
//
// The scroller is found, not assumed: from 990px up Horizon scrolls
// .page-wrapper rather than the document, so window.scrollY is frozen at 0 on
// desktop and a listener on window never fires. Same trap the header hit.
(function () {
  if (window.__pruvitSectionNav) return;
  window.__pruvitSectionNav = true;

  const nav = document.querySelector('[data-pruvit-snav]');
  if (!nav) return;

  const links = [...nav.querySelectorAll('a[href^="#"]')];
  if (!links.length) return;

  // Only in-page anchors are spy targets. A cross-page href here is not merely
  // a miss — something like './' is an invalid selector and querySelector
  // throws, taking the rest of this file with it.
  const targets = links.map((a) => {
    const href = a.getAttribute('href');
    if (!href || href.length < 2 || href.charAt(0) !== '#') return null;
    try {
      return document.querySelector(href);
    } catch {
      return null;
    }
  });

  let scroller = null;
  let active = -2;

  function findScroller() {
    let node = nav.parentElement;
    while (node && node !== document.body) {
      // No scrollHeight check: a deferred script runs before layout has
      // settled, and at that moment the wrapper may not yet overflow — which
      // made this fall back to window and silently do nothing. An ancestor
      // with overflow-y auto or scroll is the scroller whether or not it has
      // content to scroll yet.
      const overflowY = getComputedStyle(node).overflowY;
      if (overflowY === 'auto' || overflowY === 'scroll') return node;
      node = node.parentElement;
    }
    return window;
  }

  const offset = () => (scroller === window ? window.scrollY : scroller.scrollTop);

  function onScroll() {
    const y = offset();
    nav.classList.toggle('is-scrolled', y > 10);

    // The line the reader is actually reading at, not the top of the viewport:
    // a band counts as current once its top has passed under the chrome.
    // getBoundingClientRect is viewport-relative whichever element is doing
    // the scrolling, so the test is simply "has this band's top passed under
    // the chrome" — no document coordinates involved, and no separate maths
    // for the two scrollers.
    const line = nav.getBoundingClientRect().bottom + 120;
    let best = -1;
    for (let i = 0; i < targets.length; i++) {
      const target = targets[i];
      if (!target) continue;
      if (target.getBoundingClientRect().top <= line) best = i;
    }
    if (best === active) return;
    active = best;
    links.forEach((a, i) => a.classList.toggle('is-active', i === best));

    // The rail overflows on a phone, so keep the current item in view.
    const current = links[best];
    if (current && nav.firstElementChild.scrollWidth > nav.firstElementChild.clientWidth) {
      current.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
  }

  function bind() {
    const next = findScroller();
    if (next === scroller) return;
    if (scroller) scroller.removeEventListener('scroll', onScroll);
    scroller = next;
    scroller.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  bind();
  window.addEventListener('resize', bind, { passive: true });
  window.addEventListener('load', bind);
})();
